export const ActionTypes = {
    GET_TRANSACTIONS_REQUEST: 'GET_TRANSACTIONS_REQUEST',
    GET_TRANSACTIONS_SUCCESS: 'GET_TRANSACTIONS_SUCCESS',
    GET_TRANSACTIONS_FAILURE: 'GET_TRANSACTIONS_FAILURE'
}
